(function () {
	var nav = document.querySelector('.headerCollectionsNav');
	if (!nav) return;

	var mql = window.matchMedia('(min-width: 48.0625rem) and (max-width: 89.9375rem)');
	var retractedClass = 'headerCollectionsNav--retracted';

	var rafId = 0;

	function isLaptopBand() {
		return mql.matches;
	}

	function scrollY() {
		return window.scrollY || document.documentElement.scrollTop || 0;
	}

	function isRetracted() {
		return nav.classList.contains(retractedClass);
	}

	function setRetracted(retract) {
		if (retract) {
			nav.classList.add(retractedClass);
			nav.setAttribute('aria-hidden', 'true');
		} else {
			nav.classList.remove(retractedClass);
			nav.removeAttribute('aria-hidden');
		}
	}

	function apply() {
		rafId = 0;

		if (!isLaptopBand()) {
			setRetracted(false);
			return;
		}

		var y = scrollY();
		/* Strict behavior: links visible only at absolute top. */
		setRetracted(y > 0);
	}

	function scheduleApply() {
		if (rafId) return;
		rafId = window.requestAnimationFrame(apply);
	}

	function onMqlChange() {
		rafId = 0;
		apply();
	}

	mql.addEventListener('change', onMqlChange);
	window.addEventListener('scroll', scheduleApply, { passive: true });
	window.addEventListener('resize', scheduleApply, { passive: true });

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', apply);
	} else {
		apply();
	}
})();
